import React, { useEffect } from 'react';
import { trackEvent } from '@/utils/analytics';
import { Button } from '@/components/ui/button';

const AnalyticsTest: React.FC = () => {
  useEffect(() => {
    // This page view is already tracked by the AnalyticsTracker component in App.tsx
    console.log('Analytics Test page loaded');
  }, []);

  // Test functions to track different events
  const trackButtonClick = () => {
    trackEvent('test', 'button_click', 'test_button');
    console.log('Button click tracked');
  };

  const trackFormSubmit = () => {
    trackEvent('test', 'form_submit', 'test_form');
    console.log('Form submit tracked');
  };

  const trackCustomEvent = () => {
    trackEvent('test', 'custom_event', 'test_custom', 1);
    console.log('Custom event tracked');
  };

  return (
    <div className="container mx-auto p-8">
      <h1 className="text-3xl font-bold mb-6">Google Analytics Test Page</h1>
      
      <div className="mb-8">
        <p className="mb-4">This page demonstrates Google Analytics tracking. Open your browser console to see the tracking logs.</p>
        <p className="mb-4">You can also open the Network tab to see the Google Analytics requests.</p>
      </div>
      
      <div className="space-y-4">
        <div>
          <Button 
            onClick={trackButtonClick}
            className="mr-4"
          >
            Track Button Click
          </Button>
          
          <Button 
            onClick={trackFormSubmit}
            variant="outline"
            className="mr-4"
          >
            Track Form Submit
          </Button>
          
          <Button 
            onClick={trackCustomEvent}
            variant="secondary"
          >
            Track Custom Event
          </Button>
        </div>
      </div>
      
      <div className="mt-8 p-4 bg-gray-100 rounded-md">
        <h2 className="text-xl font-semibold mb-2">Tracking Events</h2>
        <p>The events tracked on this page:</p>
        <ul className="list-disc pl-6 mt-2">
          <li>Page view (automatic via AnalyticsTracker)</li>
          <li>Button click (category: 'test', action: 'button_click', label: 'test_button')</li>
          <li>Form submit (category: 'test', action: 'form_submit', label: 'test_form')</li>
          <li>Custom event (category: 'test', action: 'custom_event', label: 'test_custom', value: 1)</li>
        </ul>
      </div>
    </div>
  );
};

export default AnalyticsTest; 